<template>
  <div class="mt-3">
    <v-toolbar flat dark color="rgba(24, 28, 36, .92)">
      <v-btn
        icon
        absolute
        left
        style="top: 10px"
        :to="
          '/order_receipt/' +
          $store.state.backOffice.province +
          '/order/' +
          order_detail.order_id
        "
        target="_blank"
      >
        <v-icon>receipt</v-icon>
      </v-btn>
      <v-spacer />
      <v-toolbar-title>Order Detail Product</v-toolbar-title>
      <v-spacer />
      <v-btn
        v-if="$vuetify.breakpoint.xs"
        absolute
        right
        round
        icon
        depressed
        color="primary"
        class="black--text order-product-add-btn"
        @click="toNewDetailOrderform()"
        :disabled="
          (order_status_id == 6 &&
            $store.state.permission.order.edit_view != 3) ||
          (order_status_id == 7 &&
            $store.state.permission.order.edit_view != 3) ||
          isEditOrder
        "
      >
        <v-icon>add</v-icon>
      </v-btn>
      <v-btn
        v-else
        absolute
        right
        round
        depressed
        color="primary"
        class="black--text order-product-add-btn"
        @click="toNewDetailOrderform()"
        :disabled="
          (order_status_id == 6 &&
            $store.state.permission.order.edit_view != 3) ||
          (order_status_id == 7 &&
            $store.state.permission.order.edit_view != 3) ||
          isEditOrder ||
          $route.name == 'OrderDetailFood'
        "
      >
        <v-icon left>add</v-icon><span> Product</span>
      </v-btn>
    </v-toolbar>
    <orderDetailProductReceipt
      :dialog="receiptDialog"
      @setDialog="receiptDialog = $event"
      :dataOrder="order_detail"
    />
    <v-data-table
      :headers="headers"
      :items="order_detail.order_detail"
      hide-actions
    >
      <template slot="items" slot-scope="props">
        <tr>
          <td class="text-xs-left">
            {{ order_detail.order_detail.indexOf(props.item) + 1 }}
          </td>
          <td class="text-xs-center">{{ props.item.order_detail_store }}</td>
          <td class="text-xs-left pa-0">
            {{ props.item.order_detail_product.product_name_th }}
            <div
              v-if="props.item.order_detail_product.product_name_en != ''"
              style="color: grey; font-size: 11px"
            >
              {{ props.item.order_detail_product.product_name_en }}
            </div>
          </td>
          <td class="text-xs-center pa-0">
            {{ props.item.order_detail_amount }}
          </td>
          <td class="text-xs-center pa-0">
            {{
              parseFloat(props.item.order_detail_product_seller_price).toFixed(
                2
              )
            }}
          </td>
          <td class="text-xs-left pt-2">
            <ul
              v-for="option_info in props.item.order_detail_order_option"
              :key="`option info 1-${option_info.order_option_id}`"
            >
              <div class="text-xs-left pb-2">
                <li
                  v-for="choice_info in option_info.order_option_option_choice
                    .option_choice"
                  :key="`choice info 1-${choice_info.choice_id}`"
                >
                  <span
                    v-if="
                      option_info.order_option_option_choice.option_choice &&
                      option_info.order_option_option_choice.option_choice
                        .length > 0
                    "
                    >{{
                      option_info.order_option_option_choice.option_name_th
                    }}</span
                  >
                  -
                  {{ choice_info.choice_name_th }}
                  {{ parseFloat(choice_info.choice_price).toFixed(2) }} THB
                </li>
                <div
                  v-for="choice_info in option_info.order_option_option_choice
                    .option_choice"
                  :key="`choice info 2-${choice_info.choice_id}`"
                  style="color: grey; font-size: 11px"
                >
                  <span
                    v-if="
                      option_info.order_option_option_choice.option_name_en !=
                        null && choice_info.choice_name_en != null
                    "
                    >Option
                    {{ option_info.order_option_option_choice.option_name_en }}
                    - {{ choice_info.choice_name_en }}</span
                  >
                </div>
              </div>
            </ul>
          </td>
          <td class="text-xs-center">
            {{ props.item.order_detail_product.product_note }}
          </td>
          <td class="text-xs-center pa-0">
            {{
              parseFloat(props.item.order_detail_total_product_price).toFixed(2)
            }}
          </td>
          <td class="justify-center layout px-0">
            <v-btn
              :disabled="
                (order_status_id == 6 &&
                  $store.state.permission.order.edit_view != 3) ||
                (order_status_id == 7 &&
                  $store.state.permission.order.edit_view != 3) ||
                isEditOrder ||
                $route.name == 'OrderDetailFood'
              "
              icon
              @click="toEditDetailOrderform(props.item)"
            >
              <v-icon small>edit</v-icon>
            </v-btn>

            <v-btn
              :disabled="
                (order_status_id == 6 &&
                  $store.state.permission.order.edit_view != 3) ||
                (order_status_id == 7 &&
                  $store.state.permission.order.edit_view != 3) ||
                isEditOrder ||
                $route.name == 'OrderDetailFood' ||
                isHoldingProduct(props.item)
              "
              :loading="isHoldingProduct(props.item)"
              icon
              title="Close product today"
              @click="holdProductToday(props.item)"
            >
              <v-icon small color="red">block</v-icon>
            </v-btn>
            <v-btn
              :disabled="
                (order_status_id == 6 &&
                  $store.state.permission.order.edit_view != 3) ||
                (order_status_id == 7 &&
                  $store.state.permission.order.edit_view != 3) ||
                isEditOrder ||
                $route.name == 'OrderDetailFood'
              "
              icon
              @click="deleteItem(props.item)"
            >
              <v-icon small>delete</v-icon>
            </v-btn>
          </td>
        </tr>
        <tr
          style="background-color: #fafafa"
          v-if="
            props.index == order_detail.order_detail.length - 1 &&
            order_detail.order_discount &&
            order_detail.order_discount.product_gift &&
            order_detail.order_discount.product_gift.length > 0
          "
        >
          <td style="color: green; font-weight: bold">Free</td>
          <td colspan="2">
            <ul
              v-for="(info_gift, index_gift) in order_detail.order_discount
                .product_gift"
              :key="`Gift product 1-${index_gift}`"
            >
              <li v-if="info_gift.check == true">
                {{ info_gift.product_name_th }} จำนวน
                {{ info_gift.number }} ชิ้น
              </li>
            </ul>
          </td>
          <td colspan="6"></td>
        </tr>
      </template>
      <template slot="no-data"></template>
    </v-data-table>
    <v-divider></v-divider>
    <v-layout row wrap justify-space-between>
      <v-flex xs12 sm6 md6>
        <v-layout row wrap>
          <v-flex xs11>
            <div style="padding: 10px 0 10px 15px">
              <v-card
                flat
                style="border: 2px solid #ebebeb"
                v-if="order_detail.order_add_on_list.length"
              >
                <v-card-text
                  style="text-align: center; background-color: #ebebeb"
                >
                  Add-on
                </v-card-text>
                <v-card-text>
                  <div
                    style="display: flex; justify-content: space-between"
                    v-for="(item, index) in order_detail.order_add_on_list"
                    :key="index"
                  >
                    <div class="mt-2">
                      {{ item.add_on_name_th
                      }}<span>{{
                        item.add_on_set_price_type == "transport"
                          ? "(Transport)"
                          : "(Product)"
                      }}</span>
                    </div>
                    <div class="mt-2">฿ {{ item.add_on_price }}</div>
                  </div>
                </v-card-text>
              </v-card>
            </div>
          </v-flex>
          <v-flex xs8>
            <v-text-field
              hide-details
              class="ml-3"
              solo
              v-model="use_promo_code"
              label="Promotion code"
              :disabled="
                (order_status_id == 6 &&
                  $store.state.permission.order.edit_view != 3) ||
                (order_status_id == 7 &&
                  $store.state.permission.order.edit_view != 3) ||
                isEditOrder
              "
            ></v-text-field>
            <div
              style="
                color: red;
                padding: 10px 0 10px 20px;
                text-align: left;
                font-size: 14px;
              "
            >
              * ไม่สามารถรับของแถมจากโปรโมชั่นได้
            </div>
          </v-flex>
          <v-flex xs4>
            <v-btn
              color="primary"
              class="black--text elevation-0"
              @click="usePromotion()"
              style="margin-bottom: 39px"
              :loading="using_promo_code"
              :disabled="
                (order_status_id == 6 &&
                  $store.state.permission.order.edit_view != 3) ||
                (order_status_id == 7 &&
                  $store.state.permission.order.edit_view != 3) ||
                isEditOrder ||
                $route.name == 'OrderDetailFood'
              "
              >Confirm</v-btn
            >
          </v-flex>
        </v-layout>
        <v-card>
          <v-layout row wrap align-center>
            <v-flex xs9>
              <div
                style="
                  color: grey;
                  padding: 10px 0 10px 20px;
                  text-align: left;
                  font-size: 16px;
                "
                v-if="
                  order_detail.order_discount == null &&
                  order_detail.order_discount_code != null
                "
              >
                Recent promotion : {{ order_detail.order_discount_code }}
              </div>
              <div
                style="
                  padding: 10px 0 10px 20px;
                  text-align: left;
                  font-size: 16px;
                "
                v-if="
                  order_detail.order_discount != null &&
                  order_detail.order_discount_code != null
                "
              >
                <div>
                  Promotion code :
                  <span style="font-weight: bold">{{
                    order_detail.order_discount_code
                  }}</span>
                </div>
                <div>
                  Promotion name :
                  <span style="color: grey"
                    >{{ order_detail.order_discount.promotion_name_th }} (
                    {{ order_detail.order_discount.promotion_detail }} )</span
                  >
                </div>
              </div>
            </v-flex>
            <v-flex xs3>
              <v-btn
                @click="deletePromotion()"
                :disabled="
                  deletingPromotion || $route.name == 'OrderDetailFood'
                "
                :loading="deletingPromotion"
                v-if="
                  order_detail.order_discount != null &&
                  order_detail.order_discount_code != null
                "
                >remove</v-btn
              >
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 sm10 md6>
        <table
          style="font-size: 16px; padding: 10px 20px 10px 20px"
          width="100%"
        >
          <tr v-for="(item, i) in calAllPrice" :key="i" style="height: 30px">
            <td
              class="text-xs-left"
              :style="{
                color:
                  item.title == 'Discount :'
                    ? 'red'
                    : item.title == 'Total Price :'
                    ? 'green '
                    : '',
              }"
            >
              {{ item.title }}
            </td>
            <td
              width="40%"
              class="text-xs-right"
              :style="{
                color:
                  item.title == 'Discount :'
                    ? 'red'
                    : item.title == 'Total Price :'
                    ? 'green '
                    : '',
              }"
            >
              {{ item.data }}
            </td>
          </tr>
        </table>
      </v-flex>
    </v-layout>
    <editOrderDetailProductForm
      :order_status_id="order_status_id"
      :form="form"
      :original_data="original_data"
      :original_option="original_option"
      :dialog="editDetailProductDialog"
      @dialog="editDetailProductDialog = $event"
      :editedIndex="editedIndex"
      @setEditIndex="editedIndex = $event"
      @cloneOrder="$emit('cloneOrder')"
    />
  </div>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import { globalAxios } from "@/axios-path.js";
import editOrderDetailProductForm from "./EditOrderDetailProductForm";
import orderDetailProductReceipt from "./OrderDetailProductReceipt";
import { mapState, mapGetters } from "vuex";
export default {
  components: {
    editOrderDetailProductForm,
    orderDetailProductReceipt,
  },
  data: () => ({
    deletingPromotion: false,
    holdingProductById: {},
    dataOrder: {},
    receiptDialog: false,
    using_promo_code: false,
    use_promo_code: "",
    form: {},
    original_data: {},
    original_option: {
      multiple: [],
      single: [],
    },
    editDetailProductDialog: false,
    dialog: false,
    editedIndex: -1,
    allPrice: [
      {
        title: "Item price :",
        data: "0",
      },
      {
        title: "Small order difference price :",
        data: "0",
      },
  
      {
        title: "Total transport price :",
        data: "0",
      },
      {
        title: "Store package transport price :",
        data: "0",
      },
      {
        title: "Extra time transfer :",
        data: "0",
      },
      {
        title: "Vat :",
        data: "0",
      },
      {
        title: "Service Charge :",
        data: "0",
      },
      {
        title: "Discount :",
        data: "0",
      },
      {
        title: "Total Price :",
        data: "0",
      },
    ],
    headers: [
      {
        text: "#",
        align: "left",
        sortable: false,
      },
      {
        text: "Store",
        align: "center",
        sortable: false,
      },
      {
        text: "Product",
        align: "center",
        sortable: false,
      },
      {
        text: "Amount",
        align: "center",
        sortable: false,
      },
      {
        text: "Price",
        align: "center",
        sortable: false,
      },
      {
        text: "Option",
        align: "center",
        sortable: false,
      },
      {
        text: "Note",
        align: "center",
        sortable: false,
      },
      {
        text: "Total price",
        align: "center",
        sortable: false,
      },
      {
        text: "Actions",
        align: "center",
        sortable: false,
      },
    ],
  }),
  created() {
    this.initialize();
  },
  computed: {
    ...mapState({
      order_detail: (state) => state.fetchOrderDetailBack.order_detail,
      order_status_id: (state) => state.fetchOrderListBack.order_status_id,
    }),
    ...mapGetters({
      isEditOrder: "isEditOrder",
    }),
    calAllPrice() {
      this.allPrice[0].data =
        this.order_detail.order_total_price &&
        this.order_detail.order_total_price != null
          ? parseFloat(this.order_detail.order_total_price).toFixed(2) + " THB"
          : (0.0).toFixed(2) + " THB";
      this.allPrice[1].data =
        this.order_detail.order_small_order_difference &&
        this.order_detail.order_small_order_difference != null
          ? parseFloat(this.order_detail.order_small_order_difference).toFixed(
              2
            ) + " THB"
          : (0.0).toFixed(2) + " THB";
      this.allPrice[2].data =
        this.order_detail.order_transfer_price &&
        this.order_detail.order_transfer_price != null
          ? parseFloat(this.order_detail.order_transfer_price).toFixed(2) +
            " THB"
          : (0.0).toFixed(2) + " THB";
      this.allPrice[3].data =
        this.order_detail.order_package_extra_transport_price &&
        this.order_detail.order_package_extra_transport_price != null
          ? parseFloat(
              this.order_detail.order_package_extra_transport_price
            ).toFixed(2) + " THB"
          : (0.0).toFixed(2) + " THB";

      this.allPrice[4].data =
        this.order_detail.order_transfer_extra_time_price &&
        this.order_detail.order_transfer_extra_time_price != null
          ? parseFloat(
              this.order_detail.order_transfer_extra_time_price
            ).toFixed(2) + " THB"
          : (0.0).toFixed(2) + " THB";

      // this.allPrice[3].data =
      //   this.order_detail.order_distance != null
      //     ? parseFloat(this.order_detail.order_distance) + " m."
      //     : 0 + " m.";
      this.allPrice[5].data =
        this.order_detail.order_vat_price &&
        this.order_detail.order_vat_price != null
          ? parseFloat(this.order_detail.order_vat_price).toFixed(2) + " THB"
          : (0.0).toFixed(2) + " THB";
      this.allPrice[6].data =
        this.order_detail.order_service_charge_price &&
        this.order_detail.order_service_charge_price != null
          ? parseFloat(this.order_detail.order_service_charge_price).toFixed(
              2
            ) + " THB"
          : (0.0).toFixed(2) + " THB";

      this.allPrice[7].data =
        this.order_detail.order_total_discount_price &&
        this.order_detail.order_total_discount_price != null
          ? parseFloat(this.order_detail.order_total_discount_price).toFixed(
              2
            ) + " THB"
          : (0.0).toFixed(2) + " THB";

      this.allPrice[8].data =
        this.order_detail.order_net_price &&
        this.order_detail.order_net_price != null
          ? parseFloat(this.order_detail.order_net_price).toFixed(2) + " THB"
          : (0.0).toFixed(2) + " THB";
      return this.allPrice;
    },
  },
  methods: {
    isHoldingProduct(item) {
      try {
        const productId = item.order_detail_product.product_id;
        return this.holdingProductById[productId] === true;
      } catch (e) {
        return false;
      }
    },
    async holdProductForDate(item, holdDate) {
      let productId = null;
      let productNameTh = "";
      try {
        productId = item.order_detail_product.product_id;
        productNameTh = item.order_detail_product.product_name_th || "";
      } catch (e) {
        productId = null;
      }

      if (!productId) {
        alert("Product id not found");
        return;
      }

      const province = this.$store.state.backOffice.province;
      if (!province) {
        alert("Province not found");
        return;
      }

      const confirmText =
        "ต้องการปิดสินค้าเฉพาะวันนี้ใช่หรือไม่ ?" +
        (productNameTh ? `\nสินค้า: ${productNameTh}` : "") +
        `\nวันที่: ${holdDate}`;
      const r = confirm(confirmText);
      if (r !== true) return;

      Vue.set(this.holdingProductById, productId, true);
      try {
        const url = `/api/v1/${province}/backoffice/product/hold_today/${productId}`;
        const payload = {
          reason: "Call center ปิดชั่วคราว",
          hold_date: holdDate,
        };

        const res = await globalAxios.post(url, payload);
        if (
          res === false ||
          (typeof res.msg === "boolean" && res.msg === false)
        ) {
          alert("ไม่สามารถปิดสินค้าได้");
          return;
        }

        const created = res && res.data ? res.data.created : undefined;
        if (created === false) {
          alert("ปิดสินค้าแล้ว (มีรายการปิดอยู่แล้วสำหรับวันนี้)");
        } else {
          alert("ปิดสินค้าเรียบร้อย");
        }
      } catch (error) {
        alert("ไม่สามารถปิดสินค้าได้");
      } finally {
        Vue.set(this.holdingProductById, productId, false);
      }
    },
    async holdProductToday(item) {
      const today = moment().format("YYYY-MM-DD");
      return this.holdProductForDate(item, today);
    },
    async deletePromotion() {
      this.deletingPromotion = true;
      let check = await this.$store.dispatch(
        "fetchOrderDetailBack/deletePromotion",
        this.order_detail
      );
      if (check != false) {
        this.$emit("cloneOrder");
      }
      await this.$store.dispatch(
        "fetchOrderListBack/getOrderList",
        this.order_status_id
      );
      this.deletingPromotion = false;
    },
    async usePromotion() {
      this.using_promo_code = true;
      let check = await this.$store.dispatch(
        "fetchOrderDetailBack/usePromotion",
        {
          order_id: this.order_detail.order_id,
          use_promo_code: this.use_promo_code,
        }
      );
      if (check != 3) {
        this.$emit("cloneOrder");
      }

      await this.$store.dispatch(
        "fetchOrderListBack/getOrderList",
        this.order_status_id
      );
      if (check.promotion_status == false) {
        alert(check.data["name_" + this.$i18n.locale]);
      }

      this.using_promo_code = false;
    },
    async deleteItem(item) {
      var r = confirm("คุณต้องการลบรายการสินค้านี้ใช่หรือไม่ ?");
      if (r == true) {
        await this.$store.dispatch("fetchOrderDetailBack/deleteItem", item);
        this.$emit("cloneOrder");
        await this.$store.dispatch(
          "fetchOrderListBack/getOrderList",
          this.order_status_id
        );
      }
    },
    setForm() {
      this.form = {
        order_detail_order_id: this.order_detail.order_id,
        order_detail_product: {},
        order_detail_store: null,
        order_detail_product_seller_price: 0,
        order_detail_amount: null,
        order_detail_status: 1,
        order_detail_total_option_price: 0,
        order_detail_vat_price: 0,
        order_detail_service_charge_price: 0,
        order_detail_total_product_price: 0,
        order_detail_check_product: 0,
        order_detail_store_id: 0,
        order_detail_order_option: [],
      };
    },
    initialize() {
      this.users = [
        {
          num: "1",
          store: "กล้วยน้ำว้า",
          product: "Yogurt Icecream",
          amount: "1",
          price: "120",
          Summary: "size s",
          Paid: "เยลลี่",
          total_price: "120",
          status: "cooking",
          action: "",
        },
      ];
    },
    toNewDetailOrderform() {
      this.$store.dispatch("fetchOrderDetailBack/getStoreType");
      this.$store.dispatch("fetchOrderDetailBack/getStoreList");
      this.original_option.single = [];
      this.original_option.multiple = [];
      this.editDetailProductDialog = true;
      this.editedIndex = -1;
      this.setForm();
      // if (this.order_detail.order_type == 3) {
      this.original_data = Object.assign({}, this.order_detail.order_detail[0]);
      // }
    },
    toEditDetailOrderform(item) {
      this.$store.dispatch("fetchOrderDetailBack/getStoreType");
      this.$store.dispatch("fetchOrderDetailBack/getStoreList");
      this.original_option.single = [];
      this.original_option.multiple = [];
      for (let val of item.order_detail_order_option) {
        let index = item.order_detail_order_option.indexOf(val);
        for (let val2 of val.order_option_option_choice.option_choice) {
          let data = {
            choice_id: val2.choice_id,
            choice_name_th: val2.choice_name_th,
            choice_name_en: val2.choice_name_en,
            choice_price: parseFloat(val2.choice_price),
            choice_option_id: val.order_option_option_choice.option_id,
          };
          if (val.order_option_option_choice.option_type == 1) {
            Vue.set(this.original_option.single, index, data);
          } else {
            this.original_option.multiple.push(data);
          }
        }
      }
      this.original_data = Object.assign({}, item);
      this.form = Object.assign({}, item);
      this.editDetailProductDialog = true;
      this.editedIndex = 1;
    },
  },
};
</script>
